import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_retdeuda, p_transoli, p_prcmanual, p_ejecutivo, p_fecpago, p_finiqsinsol) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_retdeuda": p_retdeuda,
					"p_transoli": p_transoli,
					"p_prcmanual": p_prcmanual,
					"p_ejecutivo": p_ejecutivo,
					"p_fecpago": p_fecpago,
					"p_finiqsinsol": p_finiqsinsol
				  })
			})
	},

	finiquitos(p_email, p_usuario, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.recuperar_finiquito",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza
				  })
			})
	},

	transferir(p_email, p_usuario, p_registro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.transferir",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_registro": p_registro
				  })
			})
	},

	fechatransferencia(p_email, p_usuario, p_fecha, p_registro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.fechatransferencia",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecha": p_fecha,
					"p_registro": p_registro
				  })
			})
	},

	guardar_observacion(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago, p_observacion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.guardar_observacion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago,
					"p_observacion": p_observacion
				  })
			})
	},

	recuperar_mailDeudaPrima(p_email, p_usuario, p_poliza, p_beneficiario, p_retdeuda, p_transoli, p_prcmanual, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.recuperar_mailDeudaPrima",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_retdeuda": p_retdeuda,
					"p_transoli": p_transoli,
					"p_prcmanual": p_prcmanual,
					"p_fecpago": p_fecpago

				  })
			})
	},

	mail_DeudaPrima(p_email, p_usuario, p_poliza, p_beneficiario, p_retdeuda, p_transoli, p_prcmanual, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.fnc_mail_DeudaPrima",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_retdeuda": p_retdeuda,
					"p_transoli": p_transoli,
					"p_prcmanual": p_prcmanual,
					"p_fecpago": p_fecpago

				  })
			})
	},


	mail_finiquito(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.fnc_mail_finiquito",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago
				  })
			})
	},
	guardar_link_contishare(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago, p_link, p_nombredoc) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferencia.guardar_link_contishare",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago,
					"p_link": p_link,
					"p_nombredoc": p_nombredoc,
				  })
			})
	},

	
}